import Tag from './Tag';

export default Tag;



// WEBPACK FOOTER //
// ./src/components/tag/index.js